import axiosApi from "../axiosInstance";
import { getStoredCompany } from "../../helper/sessionHelper";

const getAssetGroupBulkDataList = async (fileTypeId) => {
  try {
    const response = await axiosApi.get(
      `UploadFileBulk/getAssetGroupBulkData/${fileTypeId}/${
        getStoredCompany()?.companyId || 0
      }`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getAssetGroupBulkDataList ===>", error);
    return error?.response?.data;
  }
};

const uploadAssetGroup = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(
      `UploadFileBulk/uploadAssetGroupBulkData`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error uploadAssetGroup ===>", error);
    return error?.response?.data;
  }
};

const processAssetGroup = async (body) => {
  try {
    const response = await axiosApi.post(
      `UploadFileBulk/processAssetGroupBulkData`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error processAssetGroup ===>", error);
    return error?.response?.data;
  }
};

const truncateAssetGroupBulkData = async () => {
  try {
    const response = await axiosApi.post(
      `UploadFileBulk/truncateAssetGroupBulkData`
    );
    return response?.data;
  } catch (error) {
    console.log("Error truncateAssetGroupBulkData ===>", error);
    return error?.response?.data;
  }
};

const getCategoryBulkDataList = async (fileTypeId) => {
  try {
    const response = await axiosApi.get(
      `UploadFileBulk/getCategoryBulkData/${fileTypeId}/${
        getStoredCompany()?.companyId || 0
      }`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getCategoryBulkDataList ===>", error);
    return error?.response?.data;
  }
};

const uploadCategory = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(
      `UploadFileBulk/uploadCategoryBulkData`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error uploadCategory ===>", error);
    return error?.response?.data;
  }
};

const processCategory = async (body) => {
  try {
    const response = await axiosApi.post(
      `UploadFileBulk/processCategoryBulkData`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error processCategory ===>", error);
    return error?.response?.data;
  }
};

const truncateCategoryBulkData = async () => {
  try {
    const response = await axiosApi.post(
      `UploadFileBulk/truncateCategoryBulkData`
    );
    return response?.data;
  } catch (error) {
    console.log("Error truncateCategoryBulkData ===>", error);
    return error?.response?.data;
  }
};

const getSubCategoryBulkDataList = async (fileTypeId) => {
  try {
    const response = await axiosApi.get(
      `UploadFileBulk/getSubCategoryBulkData/${fileTypeId}/${
        getStoredCompany()?.companyId || 0
      }`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getSubCategoryBulkDataList ===>", error);
    return error?.response?.data;
  }
};

const uploadSubCategory = async (body) => {
  try {
    body.companyId = getStoredCompany()?.companyId || 0;
    const response = await axiosApi.post(
      `UploadFileBulk/uploadSubCategoryBulkData`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error uploadSubCategory ===>", error);
    return error?.response?.data;
  }
};

const processSubCategory = async (body) => {
  try {
    const response = await axiosApi.post(
      `UploadFileBulk/processSubCategoryBulkData`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error processSubCategory ===>", error);
    return error?.response?.data;
  }
};

const truncateSubCategoryBulkData = async () => {
  try {
    const response = await axiosApi.post(
      `UploadFileBulk/truncateSubCategoryBulkData`
    );
    return response?.data;
  } catch (error) {
    console.log("Error truncateSubCategoryBulkData ===>", error);
    return error?.response?.data;
  }
};

const getAssetBulkDataList = async (fileTypeId) => {
  try {
    const response = await axiosApi.get(
      `UploadFileBulk/getAssetBulkData/${fileTypeId}/${
        getStoredCompany()?.companyId || 0
      }`
    );
    return response?.data;
  } catch (error) {
    console.log("Error getAssetBulkDataList ===>", error);
    return error?.response?.data;
  }
};

const uploadAsset = async (body) => {
  try {
    const response = await axiosApi.post(
      `UploadFileBulk/uploadAssetBulkData`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error uploadAsset ===>", error);
    return error?.response?.data;
  }
};

const processAsset = async (body) => {
  try {
    const response = await axiosApi.post(
      `UploadFileBulk/processAssetBulkData`,
      body
    );
    return response?.data;
  } catch (error) {
    console.log("Error processAsset ===>", error);
    return error?.response?.data;
  }
};

const truncateAssetBulkData = async () => {
  try {
    const response = await axiosApi.post(
      `UploadFileBulk/truncateAssetBulkData`
    );
    return response?.data;
  } catch (error) {
    console.log("Error truncateAssetBulkData ===>", error);
    return error?.response?.data;
  }
};

export const uploadFileService = {
  getAssetGroupBulkDataList,
  uploadAssetGroup,
  processAssetGroup,
  truncateAssetGroupBulkData,
  getCategoryBulkDataList,
  uploadCategory,
  processCategory,
  truncateCategoryBulkData,
  getSubCategoryBulkDataList,
  uploadSubCategory,
  processSubCategory,
  truncateSubCategoryBulkData,
  getAssetBulkDataList,
  uploadAsset,
  processAsset,
  truncateAssetBulkData,
};
